import { render } from "./App.vue?vue&type=template&id=26331c12"
const script = {}

import "./App.vue?vue&type=style&index=0&id=26331c12&lang=css"
script.render = render

export default script